module.exports = __webpack_public_path__ + "img/white_happy.b8e32b84.png";